import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type IGetList = GRpcRequestType<MainApi.PillFormsGrpcContractClient['GetList']>;

@Injectable()
export class PillFormsGrpcContractService extends GrpcCommonService<MainApi.PillFormsGrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.PillFormsGrpcContractClient) {
    super();
  }

  getList(request: IGetList) {
    return from(
      this._GrpcContract.GetList(
        new MainApi.GetPillFormsWpcRequest(MainApi.GetPillFormsWpcRequest.fromObject(request)),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }
}
